import * as React from 'react';

function SvgFrance(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.79h35.537V.059H0v20.73z"
        fill="#314588"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.88h35.537V.058H0V13.88z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.97h35.537V.058H0V6.97z"
        fill="#9F1330"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.734h11.846V0H0v20.734z"
        fill="#002395"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.846 20.734h11.845V0H11.846v20.734z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.691 20.734h11.847V0H23.69v20.734z"
        fill="#ED2939"
      />
    </svg>
  );
}

export default SvgFrance;
